"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleClose = void 0;
var __constants__1 = require("./__constants__");
exports.handleClose = function (_a) {
    var closeMode = _a.closeMode, closeMessage = _a.closeMessage, closeAction = _a.closeAction;
    localStorage.removeItem(__constants__1.constants.STORAGE_DATA_KEY);
    window.history.pushState({}, 'Close', "?" + __constants__1.constants.CLOSE_MODE_KEY + "=" + (closeMode || 'error') + (closeMessage
        ? "&" + __constants__1.constants.CLOSE_MESSAGE_KEY + "=" + closeMessage
        : '') + (closeAction
        ? "&" + __constants__1.constants.CLOSE_ACTION_KEY + "=" + closeAction
        : ''));
};
//# sourceMappingURL=handleClose.js.map